import "./resume.css";
import inicio2 from "../img/inicio2.jpg";
import n23 from "../img/n23.png";
import full from"../img/full.jpg"

import { ParallaxBannerLayer, ParallaxBanner } from "react-scroll-parallax";

function Intro() {
  return (
    <>
      <div className="white-bar"></div>
      <ParallaxBanner
        style={{
          maxWidth: "1600px",
          minWidth: "90vw",
          justifySelf: "center",
          paddingTop: "50px",
          paddingBottom: "300px",
        }}
      >
        <div className="intro-container-mobile">
        <img src={full}  id="fullback" />
        
        </div>

        <ParallaxBannerLayer speed={10} style={{ zIndex: 2 }}>
          <h1 id="buney">Buney Gakiya</h1>
        </ParallaxBannerLayer>

        <div className="intro-container">
          <ParallaxBannerLayer speed={-10} style={{ zIndex: 1 }}>
            <img className="intro-front" src={n23} />
          </ParallaxBannerLayer>

          <ParallaxBannerLayer speed={25}>
            <img className="intro" src={inicio2} />
          </ParallaxBannerLayer>
        </div>
      </ParallaxBanner>
    </>
  );
}

export default Intro;
